<template>
  <div class="item-agente">
    <span v-if="item.fullname.length > 15">
      <a-tooltip>
        <template #title>
          {{ item.fullname }}
        </template>
        {{ item.fullname.substring(0, 13) + "..." }}
      </a-tooltip>
    </span>
    <span v-else>
      {{ item.fullname }}
    </span>
    <EventLabel :event-management="item.current_phone_event_management?.id || item.current_phone_event_management || item.event_management?.id || item.event_management" />
  </div>
</template>

<script>
import EventLabel from "@/app/shared/components/labels/EventLabel.vue";

export default {
  components: { EventLabel },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.item-agente
  margin-left: 1px
  display: flex
  justify-content: space-between
  gap: 6px
  span:first-child
    width: 140px
.item-text
  text-align: left
</style>
